import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BRAND_NAME_TM } from "../constants/brand";

function useTitle() {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const baseTitle = BRAND_NAME_TM;
    let title = baseTitle;

    switch (location.pathname) {
      case "/":
        title = `${baseTitle} | ${t("home")}`;
        break;
      case "/login":
        title = `${baseTitle} | ${t("login")}`;
        break;
      case "/sign-up":
        title = `${baseTitle} | ${t("signUp")}`;
        break;
      case "/reset-password":
        title = `${baseTitle} | ${t("forgotPassword")}`;
        break;
      case "/reset-password/:token":
        title = `${baseTitle} | ${t("resetPassword")}`;
        break;
      case "/search":
      case "/search/:category":
      case "/search/:category/:subcategory":
        title = `${baseTitle} | ${t("resources")}`;
        break;
      case "/notifications":
      case "/notifications/:category":
        title = `${baseTitle} | ${t("alerts_posts")}`;
        break;
      case "/profile":
        title = `${baseTitle} | ${t("account_profile")}`;
        break;
      case "/favorites":
        title = `${baseTitle} | ${t("favorites")}`;
        break;
      case "/messages":
      case "/messages/:chatId":
        title = `${baseTitle} | ${t("messages")}`;
        break;
      default:
        title = baseTitle;
        break;
    }

    document.title = title;
  }, [location, t]);
}

export default useTitle;
